import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { livingCategories } from '../../data/collections';
import { livingProducts } from '../../data/livingProducts';
import { collectionPath } from '../../utils/products';
export function LivingCategories() {
  return <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-306" data-mp="2ew7yumrihijq">
      <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-307" data-mp="2000glrznyr73">Shop per categorie</h2>
      <ul className="mt-8 grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3 lg:grid-cols-5" data-id="element-308" data-mp="24yljy0a7pqzr">
        {livingCategories.map(c => {
        const count = livingProducts.filter(p => p.category === c.id).length;
        return <li key={c.id} data-id="element-309" data-mp="1vyyf14i9y31y">
              <Link to={collectionPath(c.id, 'living')} className="group flex h-full flex-col overflow-hidden rounded-xl border border-line bg-white transition-[border-color] duration-150 hover:border-majorelle" data-id="element-310" data-mp="1w09if37t58sj">
                <div className="overflow-hidden bg-stone" data-id="element-311" data-mp="25chocwv3wuu1">
                  <img src={c.image} alt="" className="aspect-square w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-312" data-mp="21bxsdwm9rx9h" />
                </div>
                <div className="flex flex-1 items-center justify-between gap-2 p-4" data-id="element-313" data-mp="2f5gmp6genzqu">
                  <span data-id="element-314" data-mp="2a51cgnrf78d3">
                    <span className="block font-semibold text-ink" data-id="element-315" data-mp="2a6lyfozo5izc">{c.title}</span>
                    <span className="block text-sm text-muted" data-id="element-316" data-mp="1mgrkf43m5odi">{count} producten</span>
                  </span>
                  <ArrowRightIcon className="h-4 w-4 shrink-0 text-majorelle transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-317" data-mp="1ifg4jqajkhii" />
                </div>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}